import React from "react";

import { hippoServices } from "./footerData";
import { Helmet } from "react-helmet";

function HippoServices() {
  return (
    <div className="service-section">
      {hippoServices.map((service) => {
        const Icon = service.svg;
        return (
          <a
            className="service-link"
            key={service.id}
            href={service.path}
            target={service.newTab ? "_blank" : "_self"}
            rel={service.newTab ? "noopener noreferrer" : ""}
            aria-label={
              service.newTab
                ? `Open ${service.title} in a new tab`
                : `Go to ${service.title}`
            }
          >
            <Icon width={service.iconWidth} height={58} />
          </a>
        );
      })}
    </div>
  );
}

export default HippoServices;
